<template>
    <div class="page-model-detail" v-if="isShow">
        <div class="detail-cont">
            <div class="top-info article-top-info">
                <div class="art-top-title">{{model.modelName}}</div>
                <div class="type-tags">
                </div>
                <div class="zc-count clearfix">
                    <i class="icon see"></i><span class="much">{{model.viewCount}}</span>
                    <i class="icon pinglun"></i><span class="much">{{model.commentCount}}</span>
                    <i class="icon fenxiang"></i><span class="much">{{model.shareCount}}</span>
                    <!-- <span class="much"><i class="el-icon-more"></i></span> -->
                    <!-- <span class="tips"><i class="el-icon-warning"></i> 未经作者授权，禁止转载</span> -->
                    <span class="date">{{model.createTime | formatTime}}</span>
                </div>
            </div>
            <div class="con-info clearfix">
                <div class="left-info">
                    <div class="play-audio">
                        <div class="pan">
                            <img class="pan-img" :class="{'paused': !playState}" :src="require('./play_audio.png')"
                                 alt="">
                            <div class="mai" :class="{'play': playState}"><img class="mai-img" :src="require('./m.png')"
                                                                               alt=""></div>
                        </div>
                        <vue-audio v-if="audioSrc != ''" :audio-src='audioSrc' @change="changeState"></vue-audio>
                    </div>
                    <div class="model-shuom">
                        <div class="tit">音效说明</div>
                        <div class="words">
                            {{model.modelDescription}}
                        </div>
                    </div>

                    <!-- 评论 -->
                    <div class="pro-work-item clearfix" style="border-top: 5px solid #f6f6f6;">
                        <div class="item-infoes">
                        </div>
                    </div>
                    <!-- 评论 -->

                </div>
                <div class="right-info">
                    <div class="price-num clearfix">
                        <div class="price" v-if="model.modelPrice > 0">￥{{model.modelPrice}}</div>
                        <div class="price" v-else>免费</div>
                        <!-- <div class="num">作品编号：112255</div> -->
                    </div>
                    <ul class="muchs clearfix">
                        <li>下载<span>{{model.downLoadCount}}</span></li>
                        <li>评论<span>{{model.commentCount}}</span></li>
                        <li>收藏<span>{{model.collectCount}}</span></li>
                    </ul>
                    <div class="btns">
                    </div>
                    <div class="geshi">
                        <div class="tit-com">文件格式：</div>
                        <div class="gs-info">
                            <div class="one-item clearfix">
                                <span class="size" v-if="model.formatStr && model.formatStr.length>2">{{model.formatStr.substr(0,model.formatStr.length-1)}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="author-info">
                        <div class="info clearifx">
                            <div class="lf-info clearfix">
                                <router-link :to="{path:'/home', query: {userId:userInfo.userId}}" class="avatar"
                                             :style="{'background-image': 'url(' + `http://iss.21teacher.com/avatar/125/${userInfo.userId}/20.jpg` + ')'}"></router-link>
                                <div class="name-qm">
                                    <div class="nm oe">
                                        <router-link :to="{path:'/home', query: {userId:userInfo.userId}}">
                                            {{userInfo.userName}}
                                        </router-link>
                                    </div>
                                    <div class="qm oe">{{userInfo.signature}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="audio-works clearfix">
                            <router-link class="itemm" target="_blank" v-for="(item, index) in modelList" :key="index"
                                         :to="{path:'/audio/detail', query: {id:item.id,plate:3}}">
                                <img :src="require('@/assets/images/audio_img.png')" alt="">
                                <p>{{item.modelName}}</p>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import axios from 'axios';
    import vue from 'vue';
    import modelApi from '@/api/model'
    import updateTdk from "@/utils/tdk";
    import {mapState} from "vuex";
    import VueAudio from './vueAudio'

    vue.prototype.$axios = axios;
    export default {
        components: {
            VueAudio,
        },
        data() {
            return {
                isShow: false,
                headTitle: "title---rrdh",
                headKeywords: "keywords---rrdh",
                headDesc: "description---rrdh",
                isMounted: false, //for control not ssr render
                pics: [],
                model: {},
                tags: [],
                fileList: [],
                fileFormats: [],
                modelList: [],
                userInfo: {},
                callbackurl: "",
                isReload: true,
                objId: 0,
                payStatus: false,
                playState: false,
                audioSrc: '',
            }
        },
        beforeMount() {
            // let id = this.$route.query.id
            // if (id) {
            //   this.objId = parseInt(id)
            // }
            // console.log('--------',id)

        },
        computed: {
            ...mapState(["modelDetail"])
        },
        tdk() {
            return {
                title: this.headTitle,
                description: this.headDesc,
                keywords: this.headKeywords,
                ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
            };
        },
        serverPrefetch() {
            return this.fetchData();
        },
        destroyed() {
            this.$store.commit("SET_MODEL_DETAIL", {detail: null});
        },
        mounted() {
            this.isMounted = true;
            // let id = this.$route.query.id
            this.callbackurl = "login?callback=" + window.location.href;

            const alreadyIncremented = !!this.modelDetail;
            if (!alreadyIncremented) {
                this.fetchData().then(
                    setTimeout(() => {
                        this.initData()
                    }, 1500)
                );
            } else {
                setTimeout(() => {
                    this.initData()
                }, 500)
            }
        },
        methods: {
            changeState(state) {
                // console.log(state)
                this.playState = state
            },
            setSeo() {
                this.headTitle = this.modelDetail.modelName + "——人人动画网【官网】";
                this.headKeywords = this.modelDetail.modelDescription;
                let desc = this.modelDetail.modelDescription.replace(/<\/?.+?>/g, "").trim()
                this.headDesc = desc.substr(0, 150);
            },
            fetchData() {
                return this.$store
                    .dispatch("FETCH_MODEL_DETAIL", {
                        id: this.$route.query.id
                    })
                    .finally(() => {
                        this.$loading(false);
                        this.setSeo()
                        updateTdk.call(this);
                    });
            },
            initData() {
                let _this = this;
                _this.model = _this.modelDetail
                _this.objId = parseInt(_this.model.id)
                modelApi.select(_this.objId).then(data => {
                    if (data.code == 1) {
                        _this.model = data.response
                        if (_this.model.deleteFlag == 1) {
                            this.$router.push({
                                path: '/error',
                            })
                        } else {
                            _this.isShow = true
                            _this.userThreeModel(_this.model.creatorId);
                            _this.getUserInfo(_this.model.creatorId)
                            _this.fileList = data.response.fileList
                            _this.audioSrc = _this.fileList[0].url
                        }

                    } else {
                        _this.$message.error(data.message)
                    }
                })
            },
            userThreeModel(userId) {
                let _this = this
                modelApi.userThreeModel(userId, 2).then(data => {
                    if (data.code == 1) {
                        _this.modelList = data.response
                    }
                })
            },
            getUserInfo(userId) {
                let _this = this;
                let url = '/rrbi/userInfo/userInfo/' + userId + '?time=' + new Date().getMilliseconds();
                _this.$axios.get(url).then(function (result) {
                    if (result.data.code == 1) {
                        _this.userInfo = result.data.response
                    }
                })
            },

            reloadModel() {
                let _this = this
                // 移除组件
                _this.isReload = false
                // 在组件移除后，重新渲染组件
                // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
                _this.$nextTick(() => {
                    _this.isReload = true
                })
            },
            toLog() {
                this.$router.push({
                    path: '/login?callback=' + window.location.href,
                })

            },
        }

    }
</script>

<style scoped lang="less">
    //@import "../../../../assets/less/stylePublic.less";
    @import "../../../model/detail/detail.less";

    .play-audio {
        padding: 20px;
        width: 100%;

        .pan {
            position: relative;
            margin: 0 auto;
            width: 50%;

            .pan-img {
                display: block;
                width: 100%;
                animation: rotatePan 15s linear 0s infinite;
                @keyframes rotatePan {
                    0% {
                        transform: rotate(-360deg);
                    }
                    100% {
                        transform: rotate(0deg);
                    }
                }

                &.paused {
                    animation-play-state: paused;
                }

                &::selection {
                    background: none;
                }
            }

            .mai {
                position: absolute;
                right: -24%;
                top: 0;
                width: 25%;
                transform-origin: 60% 15.9%;
                transform: rotate(0deg);
                transition: transform .2s linear;

                &.play {
                    transform: rotate(40deg);
                }

                .mai-img {
                    display: block;
                    width: 100%;

                    &::selection {
                        background: none;
                    }
                }
            }
        }
    }

    .audio-works {
        margin-top: 10px;

        .itemm {
            float: left;
            padding: 4px;
            margin-right: 2.3%;
            width: 31.8%;
            background: #fff;
            border: 1px solid #dfdee3;
            border-radius: 2px;

            img {
                margin: 0 auto;
                display: block;
                width: 40px;
                height: 40px;
            }

            p {
                margin-top: 5px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-size: 12px;
            }

            &:last-child {
                margin-right: 0;
            }
        }
    }

    @media screen and (max-width: 750px) {
        .play-audio {
            padding: 0;
        }
    }
</style>
